import React from "react";
import Button from "@mui/material/Button";
import { useNavigate} from "react-router-dom";
import { useSelector } from "react-redux";
import useRudderStackAnalytics from "../config/useRudderAnalytics";
export default function Home(){
    const useRudderAnalytics=useRudderStackAnalytics();
    const navigate=useNavigate();
    const driverJobTitle=useSelector(state=>state.driver.entities.currDriver?.driverJobTitle);
    const driverId=useSelector(state=>state.driver.entities.currDriver?.driverId);
    const driverName=useSelector(state=>state.driver.entities.currDriver?.driverName);
    React.useEffect(()=>{
        if(driverId && useRudderAnalytics){
            useRudderAnalytics.page("Home")
        }
    },[driverId, useRudderAnalytics])
    return (
        <>
        {driverId&&<div style={{display:"flex", justifyContent:"center", alignItems:"center", flexDirection:"column",overflow:"hidden"}}>
            <p style={{fontStyle:"italic"}}>You are currently logged in as:</p>
            <h3 style={{textDecoration:"underline"}}>{driverName}</h3>
        </div>}
        {!driverId&&<div style={{display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center", height:"80vh", flexDirection:"column",overflow:"hidden"}}>
            <p style={{fontStyle:"italic"}}>You are not logged in, please enter valid URL or contact your manager</p>
        </div>}
        <div style={{display:"flex", justifyContent:"center", alignItems:"center", gap:"40px", flexDirection:"column", height:"50vh", overflow:"hidden"}}>
           {driverId&&<>
            <Button onClick={()=>navigate("haccp")} className="listReport" variant="contained">HP 06 Daily Delivery Report (HACCP)</Button>
           {driverJobTitle && !driverJobTitle.toLowerCase().includes("contractor")&&<Button onClick={()=>navigate("whs")} className="listReport" variant="contained">DN 010.4 Motor Vehicle Inspection (WHS)</Button>}
           </>}

        </div>
    
        </>)
}